import { render, staticRenderFns } from "./biaoge.vue?vue&type=template&id=53ee4eaa&"
import script from "./biaoge.vue?vue&type=script&lang=js&"
export * from "./biaoge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports